export const translations = {
  fr: {
    nav: {
      home: "Accueil",
      centres: "Centres",
      services: "Nos Services",
      team: "Notre Équipe",
      blog: "Actualités",
      collaborate: "Collaborez",
      contact: "Contact",
    },
    hero: {
      subtitle: "Centres Médicaux à Bruxelles",
      description: "Deux adresses au service de votre santé — Cinquantenaire et Ixelles",
      cta_services: "Nos Services",
      cta_contact: "Nous Contacter",
    },
    news: {
      title: "Actualités",
      blood_test: "Service Prélèvement & Prises de Sang actif sur RDV avec le Dr Hendrickx",
      new_center: "Psymed Abbaye : notre nouveau centre à Ixelles est ouvert",
      professional: "Professionnel de santé ? Contactez-nous pour collaborer",
    },
    about: {
      title: "Psymed",
      subtitle: "Deux centres médicaux et paramédicaux à Bruxelles, une même équipe pluridisciplinaire",
      description:
        "Psymed regroupe aujourd'hui deux centres médicaux à Bruxelles. Notre premier centre, ouvert en janvier 2020, se situe au cœur du Parc du Cinquantenaire, à proximité des institutions européennes. Notre nouveau centre, Psymed Abbaye, a récemment ouvert ses portes au cœur du quartier des Étangs d'Ixelles.",
      description2:
        "Les deux centres travaillent en synergie et partagent une même équipe pluridisciplinaire et multilingue, expérimentée et engagée. Cette collaboration permet à nos patients de bénéficier d'un éventail élargi de soins médicaux, paramédicaux et psychologiques, dans un cadre chaleureux et professionnel.",
      stat1: "2 centres à Bruxelles",
      stat2: "Équipe multilingue",
      stat3: "8+ disciplines",
      stat4: "Depuis 2020",
    },
    services: {
      title: "Nos Services et Soins",
      subtitle: "Soins & Disciplines",
      learn_more: "En savoir plus",
      list: [
        { id: 1, name: "Dermatologie et Vénéréologie", desc: "Consultation dermatologique, traitement des maladies de peau et des IST, dermatologie esthétique" },
        { id: 2, name: "Logopédie", desc: "Évaluation et traitement des troubles du langage, de la parole et de la communication" },
        { id: 3, name: "Médecine Générale", desc: "Consultations médicales, suivi de santé et prises de sang sur rendez-vous" },
        { id: 4, name: "Pédicure Médicale Spécialisée", desc: "Soins médicaux spécialisés des pieds et des ongles" },
        { id: 5, name: "Psychologie Première Ligne", desc: "Soutien psychologique et psychothérapie individuelle première ligne" },
        { id: 6, name: "Psychothérapie Systémique", desc: "Thérapie du couple, familiale et systémique" },
        { id: 7, name: "Psychanalyse et EMDR", desc: "Psychothérapie analytique et traitement EMDR des traumatismes" },
        { id: 8, name: "Laser Anti-Tabac & Addictions", desc: "Traitement laser auriculaire pour l'arrêt du tabac et des addictions" },
      ],
    },
    gallery: {
      title: "Notre Espace",
      subtitle: "Un cadre chaleureux et professionnel",
    },
    centres: {
      eyebrow: "Deux adresses à Bruxelles",
      title: "Nos Centres Médicaux",
      subtitle: "Deux centres complémentaires travaillant en synergie pour offrir des soins pluridisciplinaires de qualité au cœur de Bruxelles.",
      discover: "Découvrir ce centre",
      back: "Retour aux centres",
      all_centres: "Tous nos centres",
      features: "Points forts",
      gallery: "Galerie",
      contact: "Contact",
      transport: "Accès & Transports",
      open_map: "Ouvrir dans Maps",
      team: "L'équipe de ce centre",
      home_title: "Nos deux centres",
      home_subtitle: "Deux adresses, un même engagement pour votre santé.",
    },
    collaborer: {
      eyebrow: "Rejoignez le réseau Psymed",
      title: "Collaborez avec nous",
      intro: "Vous êtes médecin, kinésithérapeute, psychologue, psychothérapeute ou tout autre professionnel de la santé à la recherche d\'un cabinet accueillant, bien situé et pleinement équipé ? Rejoignez le réseau Psymed.",
      abbaye_title: "Centre Psymed Abbaye — Avenue de l\'Hippodrome, Ixelles",
      abbaye_lead: "Avec un permis d\'urbanisme de la commune d\'Ixelles, notre nouveau centre vous propose 7 cabinets médicaux/paramédicaux avec point d\'eau et une salle polyvalente, dans un bâtiment entièrement rénové de 280 m², au cœur des Étangs d\'Ixelles — à deux pas de la place Flagey et du quartier universitaire (ULB), avec une excellente desserte en transports en commun (trams 7 & 8, bus 38/59/71).",
      abbaye_pmr: "Intégralement accessible aux personnes à mobilité réduite (PMR), avec une place dépose-minute juste devant l\'entrée.",
      features_title: "Ce que vous trouverez sur place",
      features: [
        "7 cabinets de 17 à 23 m², métrage généreux conforme aux normes, mobilier et lavabo intégrés",
        "Salle polyvalente de 35 m² (sous-sol) — rééducation, formation, réunions ou soirées à thème, louable indépendamment",
        "Kitchenette équipée, vestiaire et douche",
        "2 toilettes dont une PMR",
        "Ventilation mécanique contrôlée (VMC)"
      ],
      pricing_title: "Formules souples, charges comprises",
      pricing_note: "Votre profil professionnel présent sur le site du centre",
      half_day: "Demi-journée fixe / semaine",
      half_day_price: "à partir de 155 €/mois",
      full_day: "Journée complète fixe / semaine",
      full_day_price: "à partir de 280 €/mois",
      cinquantenaire_title: "Centre Psymed Cinquantenaire",
      cinquantenaire_body: "Notre centre historique, situé à deux pas du parc du Cinquantenaire, accueille des professionnels de la santé depuis 2020. Les places y sont désormais très limitées : il ne reste que de rares disponibilités, alors n\'attendez pas pour nous contacter si un cabinet dans ce cadre vous intéresse.",
      cta_title: "Envie de nous rejoindre ?",
      cta_body: "Contactez-nous pour organiser une visite et discuter de la formule la plus adaptée à votre pratique.",
      contact_email: "dottbb@outlook.com",
      contact_phone: "+32 465 64 71 08",
    },
    blog: {
      title: "Actualités",
      subtitle: "Dernières nouvelles du Centre Psymed",
      read_more: "Lire la suite",
      view_all: "Voir toutes les actualités",
      no_posts: "Aucun article disponible pour le moment.",
      back: "Retour aux actualités",
      all: "Toutes",
      not_found_title: "Article introuvable",
      not_found_text: "Cet article n'existe pas ou a été supprimé.",
    },
    contact: {
      title: "Contactez-nous",
      subtitle: "Deux centres à votre écoute, un seul formulaire",
      name: "Votre nom",
      email: "Votre email",
      phone: "Téléphone (optionnel)",
      centre_label: "Quel centre vous intéresse ?",
      centre_any: "Peu importe / les deux",
      message: "Votre message",
      send: "Envoyer",
      sending: "Envoi en cours...",
      success: "Message envoyé avec succès ! Nous vous répondrons dans les plus brefs délais.",
      error: "Une erreur est survenue. Veuillez réessayer.",
      address_title: "Adresse",
      address: "Avenue de la Renaissance 21, 1000 Bruxelles",
      building: "Résidence Da Vinci — rez-de-chaussée gauche",
      parking: "Parking : facile de trouver un emplacement",
      transport_title: "Transports en commun",
      transport_metro: "Métro: lignes 1 et 5 (Schuman ou Merode)",
      transport_bus: "Bus: 61 (Chevalerie) | 21, 63, 79 (Michelange)",
      get_directions: "Itinéraire",
    },
    staff: {
      title: "Notre Équipe",
      subtitle: "Des professionnels expérimentés à votre service",
      appointment: "Prendre RDV",
      schedule: "Horaires",
      phone: "Téléphone",
      email: "Email",
      learn_more: "En savoir plus",
      back_to_team: "Retour à l'équipe",
      practice_at: "Consulte à",
      qualifications: "Qualifications",
      domains: "Domaines d'intervention",
      memberships: "Affiliations",
      registrations: "Numéros d'enregistrement",
      about: "À propos",
      book_online: "Réserver en ligne",
      contact_pro: "Contacter",
      information: "Information",
    },
    footer: {
      tagline: "Centre médical pluridisciplinaire au cœur de Bruxelles",
      quick_links: "Liens rapides",
      privacy: "Politique de confidentialité",
      rights: "Tous droits réservés",
      professional: "Professionnel de santé ? Contactez-nous pour collaborer",
    },
  },

  nl: {
    nav: {
      home: "Home",
      centres: "Centra",
      services: "Onze Diensten",
      team: "Ons Team",
      blog: "Nieuws",
      collaborate: "Samenwerken",
      contact: "Contact",
    },
    hero: {
      subtitle: "Medisch Centrum in Brussel",
      description: "In het hart van het Jubelpark, nabij de Europese instellingen",
      cta_services: "Onze Diensten",
      cta_contact: "Neem Contact Op",
    },
    news: {
      title: "Nieuws",
      blood_test: "Bloedafname dienst actief op afspraak met Dr. Hendrickx",
      new_center: "Psymed Abbaye: ons nieuwe centrum in Elsene is nu open",
      professional: "Zorgprofessional? Neem contact op voor samenwerking",
    },
    about: {
      title: "Psymed",
      subtitle: "Twee medische en paramedische centra in Brussel, één multidisciplinair team",
      description:
        "Psymed omvat vandaag twee medische centra in Brussel. Ons eerste centrum, geopend in januari 2020, ligt in het hart van het Jubelpark, dicht bij de Europese instellingen. Ons nieuwe centrum, Psymed Abbaye, opende onlangs zijn deuren in het hart van de Vijverswijk in Elsene.",
      description2:
        "De twee centra werken in synergie samen en delen hetzelfde multidisciplinaire en meertalige team, ervaren en toegewijd. Deze samenwerking biedt onze patiënten een breed scala aan medische, paramedische en psychologische zorg, in een warme en professionele omgeving.",
      stat1: "2 centra in Brussel",
      stat2: "Meertalig team",
      stat3: "8+ disciplines",
      stat4: "Sinds 2020",
    },
    services: {
      title: "Onze Diensten en Zorg",
      subtitle: "Zorg & Disciplines",
      learn_more: "Meer info",
      list: [
        { id: 1, name: "Dermatologie en Venereologie", desc: "Dermatologisch consult, behandeling van huidziekten en seksueel overdraagbare aandoeningen" },
        { id: 2, name: "Logopedie", desc: "Evaluatie en behandeling van taal-, spraak- en communicatiestoornissen" },
        { id: 3, name: "Huisartsgeneeskunde", desc: "Algemene medische consulten, gezondheidsbegeleiding en bloedafname op afspraak" },
        { id: 4, name: "Medische Pedicure", desc: "Gespecialiseerde medische voetverzorging en nagelbehandeling" },
        { id: 5, name: "Eerstelijnspsychologie", desc: "Psychologische ondersteuning en individuele psychotherapie" },
        { id: 6, name: "Systeemtherapie", desc: "Relatie-, gezins- en systeemtherapie" },
        { id: 7, name: "Psychoanalyse en EMDR", desc: "Analytische psychotherapie en EMDR-traumabehandeling" },
        { id: 8, name: "Laser Rookstopbehandeling", desc: "Laserbehandeling voor stoppen met roken en verslavingen" },
      ],
    },
    gallery: {
      title: "Onze Ruimte",
      subtitle: "Een warme en professionele omgeving",
    },
    centres: {
      eyebrow: "Twee adressen in Brussel",
      title: "Onze Medische Centra",
      subtitle: "Twee complementaire centra die in synergie werken om multidisciplinaire kwaliteitszorg te bieden in het hart van Brussel.",
      discover: "Ontdek dit centrum",
      back: "Terug naar centra",
      all_centres: "Al onze centra",
      features: "Sterke punten",
      gallery: "Galerij",
      contact: "Contact",
      transport: "Toegang & Vervoer",
      open_map: "Openen in Maps",
      team: "Het team van dit centrum",
      home_title: "Onze twee centra",
      home_subtitle: "Twee adressen, dezelfde toewijding voor uw gezondheid.",
    },
    collaborer: {
      eyebrow: "Sluit u aan bij het Psymed-netwerk",
      title: "Werk samen met ons",
      intro: "Bent u arts, kinesitherapeut, psycholoog, psychotherapeut of een andere zorgverlener op zoek naar een gastvrije, goed gelegen en volledig uitgeruste praktijkruimte? Sluit u aan bij het Psymed-netwerk.",
      abbaye_title: "Centrum Psymed Abbaye — Renbaanlaan, Elsene",
      abbaye_lead: "Met een stedenbouwkundige vergunning van de gemeente Elsene biedt ons nieuwe centrum u 7 medische/paramedische praktijkruimtes met waterpunt en een polyvalente zaal, in een volledig gerenoveerd gebouw van 280 m², in het hart van de Vijverswijk — op een boogscheut van het Flageyplein en de universitaire wijk (ULB), met uitstekende bereikbaarheid (trams 7 & 8, bus 38/59/71).",
      abbaye_pmr: "Volledig toegankelijk voor personen met beperkte mobiliteit, met kortparkeerplaats voor de ingang.",
      features_title: "Wat u ter plaatse vindt",
      features: [
        "7 praktijken van 17 tot 23 m², royale afmetingen, meubilair en geïntegreerde wastafel",
        "Polyvalente zaal van 35 m² (kelder) — revalidatie, opleiding, vergaderingen, ook apart te huur",
        "Uitgeruste kitchenette, kleedkamer en douche",
        "2 toiletten waarvan één toegankelijk",
        "Mechanische ventilatie (VMC)"
      ],
      pricing_title: "Flexibele formules, kosten inbegrepen",
      pricing_note: "Uw professionele profiel op de website van het centrum",
      half_day: "Vaste halve dag / week",
      half_day_price: "vanaf € 155/maand",
      full_day: "Vaste volledige dag / week",
      full_day_price: "vanaf € 280/maand",
      cinquantenaire_title: "Centrum Psymed Cinquantenaire",
      cinquantenaire_body: "Ons historische centrum, op een boogscheut van het Jubelpark, verwelkomt sinds 2020 zorgverleners. De beschikbaarheid is nu zeer beperkt: aarzel niet om ons te contacteren.",
      cta_title: "Wilt u zich bij ons aansluiten?",
      cta_body: "Neem contact met ons op om een bezoek te organiseren en de beste formule te bespreken.",
      contact_email: "dottbb@outlook.com",
      contact_phone: "+32 465 64 71 08",
    },
    blog: {
      title: "Nieuws",
      subtitle: "Laatste nieuws van Centrum Psymed",
      read_more: "Lees meer",
      view_all: "Bekijk al het nieuws",
      no_posts: "Momenteel geen artikelen beschikbaar.",
      back: "Terug naar nieuws",
      all: "Alle",
      not_found_title: "Artikel niet gevonden",
      not_found_text: "Dit artikel bestaat niet of is verwijderd.",
    },
    contact: {
      title: "Neem Contact Op",
      subtitle: "Wij staan voor u klaar",
      name: "Uw naam",
      email: "Uw e-mail",
      phone: "Telefoon (optioneel)",
      centre_label: "Welk centrum interesseert u?",
      centre_any: "Maakt niet uit / beide",
      message: "Uw bericht",
      send: "Versturen",
      sending: "Versturen...",
      success: "Bericht succesvol verzonden! We nemen zo spoedig mogelijk contact met u op.",
      error: "Er is een fout opgetreden. Probeer opnieuw.",
      address_title: "Adres",
      address: "Avenue de la Renaissance 21, 1000 Brussel",
      building: "Résidence Da Vinci — begane grond links",
      parking: "Parkeren: makkelijk een parkeerplaats te vinden",
      transport_title: "Openbaar vervoer",
      transport_metro: "Metro: lijnen 1 en 5 (Schuman of Merode)",
      transport_bus: "Bus: 61 (Chevalerie) | 21, 63, 79 (Michelange)",
      get_directions: "Route plannen",
    },
    staff: {
      title: "Ons Team",
      subtitle: "Ervaren professionals in uw dienst",
      appointment: "Afspraak",
      schedule: "Uren",
      phone: "Telefoon",
      email: "E-mail",
      learn_more: "Meer info",
      back_to_team: "Terug naar het team",
      practice_at: "Praktijk in",
      qualifications: "Kwalificaties",
      domains: "Werkgebieden",
      memberships: "Lidmaatschappen",
      registrations: "Registratienummers",
      about: "Over mij",
      book_online: "Online boeken",
      contact_pro: "Contact",
      information: "Informatie",
    },
    footer: {
      tagline: "Multidisciplinair medisch centrum in het hart van Brussel",
      quick_links: "Snelle links",
      privacy: "Privacybeleid",
      rights: "Alle rechten voorbehouden",
      professional: "Zorgprofessional? Neem contact op voor samenwerking",
    },
  },

  en: {
    nav: {
      home: "Home",
      centres: "Centres",
      services: "Our Services",
      team: "Our Team",
      blog: "News",
      collaborate: "Collaborate",
      contact: "Contact",
    },
    hero: {
      subtitle: "Medical Centre in Brussels",
      description: "In the heart of Cinquantenaire Park, close to the European institutions",
      cta_services: "Our Services",
      cta_contact: "Contact Us",
    },
    news: {
      title: "News",
      blood_test: "Blood test service available by appointment with Dr. Hendrickx",
      new_center: "Psymed Abbaye: our new centre in Ixelles is now open",
      professional: "Healthcare professional? Contact us about collaboration opportunities",
    },
    about: {
      title: "Psymed",
      subtitle: "Two medical and paramedical centres in Brussels, one multidisciplinary team",
      description:
        "Psymed brings together two medical centres in Brussels today. Our first centre, opened in January 2020, is located in the heart of Cinquantenaire Park, near the European institutions. Our new centre, Psymed Abbaye, recently opened its doors in the Étangs d'Ixelles district.",
      description2:
        "Both centres work in synergy and share the same multidisciplinary and multilingual team, experienced and dedicated. This collaboration offers our patients a wide range of medical, paramedical and psychological care, in a warm and professional setting.",
      stat1: "2 centres in Brussels",
      stat2: "Multilingual team",
      stat3: "8+ disciplines",
      stat4: "Since 2020",
    },
    services: {
      title: "Our Services and Care",
      subtitle: "Care & Disciplines",
      learn_more: "Learn more",
      list: [
        { id: 1, name: "Dermatology & Venereology", desc: "Dermatological consultations, treatment of skin diseases, STIs and aesthetic dermatology" },
        { id: 2, name: "Speech Therapy", desc: "Assessment and treatment of language, speech and communication disorders" },
        { id: 3, name: "General Medicine", desc: "Medical consultations, health monitoring and blood tests by appointment" },
        { id: 4, name: "Specialised Medical Pedicure", desc: "Specialised medical foot and nail care" },
        { id: 5, name: "First-Line Psychology", desc: "Psychological support and individual first-line psychotherapy" },
        { id: 6, name: "Systemic Psychotherapy", desc: "Couple, family and systemic therapy" },
        { id: 7, name: "Psychoanalysis & EMDR", desc: "Analytical psychotherapy and EMDR trauma treatment" },
        { id: 8, name: "Laser Stop Smoking", desc: "Auricular laser treatment for smoking cessation and addictions" },
      ],
    },
    gallery: {
      title: "Our Space",
      subtitle: "A warm and professional environment",
    },
    centres: {
      eyebrow: "Two addresses in Brussels",
      title: "Our Medical Centres",
      subtitle: "Two complementary centres working in synergy to offer quality multidisciplinary care in the heart of Brussels.",
      discover: "Discover this centre",
      back: "Back to centres",
      all_centres: "All our centres",
      features: "Highlights",
      gallery: "Gallery",
      contact: "Contact",
      transport: "Access & Transport",
      open_map: "Open in Maps",
      team: "The team at this centre",
      home_title: "Our two centres",
      home_subtitle: "Two addresses, one commitment to your health.",
    },
    collaborer: {
      eyebrow: "Join the Psymed network",
      title: "Work with us",
      intro: "Are you a doctor, physiotherapist, psychologist, psychotherapist or any other healthcare professional looking for a welcoming, well-located and fully equipped practice? Join the Psymed network.",
      abbaye_title: "Psymed Abbaye centre — Avenue de l\'Hippodrome, Ixelles",
      abbaye_lead: "With an urban planning permit from the Municipality of Ixelles, our new centre offers 7 medical/paramedical practice rooms with running water and a multipurpose room, in a fully renovated 280 m² building, in the heart of the Étangs d\'Ixelles district — steps from Place Flagey and the ULB university district, with excellent public transport (trams 7 & 8, bus 38/59/71).",
      abbaye_pmr: "Fully accessible to people with reduced mobility, with a drop-off parking spot in front of the entrance.",
      features_title: "What you will find on site",
      features: [
        "7 practice rooms from 17 to 23 m², generous size meeting standards, furniture and integrated sink",
        "35 m² multipurpose room (basement) — rehabilitation, training, meetings, also available for separate rental",
        "Equipped kitchenette, changing room and shower",
        "2 toilets including one accessible",
        "Mechanical ventilation (VMC)"
      ],
      pricing_title: "Flexible packages, utilities included",
      pricing_note: "Your professional profile featured on the centre website",
      half_day: "Fixed half-day / week",
      half_day_price: "from €155/month",
      full_day: "Fixed full day / week",
      full_day_price: "from €280/month",
      cinquantenaire_title: "Psymed Cinquantenaire centre",
      cinquantenaire_body: "Our historical centre, a stone\'s throw from Cinquantenaire Park, has welcomed healthcare professionals since 2020. Availability is now very limited: contact us soon if interested.",
      cta_title: "Interested in joining us?",
      cta_body: "Contact us to arrange a visit and discuss the best formula for your practice.",
      contact_email: "dottbb@outlook.com",
      contact_phone: "+32 465 64 71 08",
    },
    blog: {
      title: "News",
      subtitle: "Latest news from Psymed Centre",
      read_more: "Read more",
      view_all: "View all news",
      no_posts: "No articles available at the moment.",
      back: "Back to news",
      all: "All",
      not_found_title: "Article not found",
      not_found_text: "This article does not exist or has been removed.",
    },
    contact: {
      title: "Contact Us",
      subtitle: "Two centres at your service, one form",
      name: "Your name",
      email: "Your email",
      phone: "Phone (optional)",
      centre_label: "Which centre are you interested in?",
      centre_any: "No preference / both",
      message: "Your message",
      send: "Send",
      sending: "Sending...",
      success: "Message sent successfully! We will get back to you as soon as possible.",
      error: "An error occurred. Please try again.",
      address_title: "Address",
      address: "Avenue de la Renaissance 21, 1000 Brussels",
      building: "Résidence Da Vinci — ground floor left",
      parking: "Parking: easy to find a spot",
      transport_title: "Public transport",
      transport_metro: "Metro: lines 1 and 5 (Schuman or Merode)",
      transport_bus: "Bus: 61 (Chevalerie) | 21, 63, 79 (Michelange)",
      get_directions: "Get directions",
    },
    staff: {
      title: "Our Team",
      subtitle: "Experienced professionals at your service",
      appointment: "Book Appointment",
      schedule: "Schedule",
      phone: "Phone",
      email: "Email",
      learn_more: "Learn more",
      back_to_team: "Back to team",
      practice_at: "Consults at",
      qualifications: "Qualifications",
      domains: "Areas of intervention",
      memberships: "Memberships",
      registrations: "Registration numbers",
      about: "About",
      book_online: "Book online",
      contact_pro: "Contact",
      information: "Information",
    },
    footer: {
      tagline: "Multidisciplinary medical centre in the heart of Brussels",
      quick_links: "Quick links",
      privacy: "Privacy policy",
      rights: "All rights reserved",
      professional: "Healthcare professional? Contact us about collaboration",
    },
  },

  it: {
    nav: {
      home: "Home",
      centres: "Centri",
      services: "I Nostri Servizi",
      team: "Il Nostro Team",
      blog: "Notizie",
      collaborate: "Collabora",
      contact: "Contatto",
    },
    hero: {
      subtitle: "Centro Medico a Bruxelles",
      description: "Nel cuore del Parco del Cinquantenario, vicino alle istituzioni europee",
      cta_services: "I Nostri Servizi",
      cta_contact: "Contattaci",
    },
    news: {
      title: "Notizie",
      blood_test: "Servizio prelievi del sangue attivo su appuntamento con il Dr. Hendrickx",
      new_center: "Psymed Abbaye: il nostro nuovo centro a Ixelles è ora aperto",
      professional: "Professionista sanitario? Contattaci per collaborare",
    },
    about: {
      title: "Psymed",
      subtitle: "Due centri medici e paramedici a Bruxelles, un unico team multidisciplinare",
      description:
        "Psymed riunisce oggi due centri medici a Bruxelles. Il nostro primo centro, aperto nel gennaio 2020, si trova nel cuore del Parco del Cinquantenaire, vicino alle istituzioni europee. Il nostro nuovo centro, Psymed Abbaye, ha recentemente aperto le sue porte nel cuore del quartiere degli Étangs di Ixelles.",
      description2:
        "I due centri lavorano in sinergia e condividono la stessa équipe multidisciplinare e multilingue, esperta e motivata. Questa collaborazione offre ai nostri pazienti una vasta gamma di cure mediche, paramediche e psicologiche, in un ambiente accogliente e professionale.",
      stat1: "2 centri a Bruxelles",
      stat2: "Team multilingue",
      stat3: "8+ discipline",
      stat4: "Dal 2020",
    },
    services: {
      title: "I Nostri Servizi e Cure",
      subtitle: "Cure & Discipline",
      learn_more: "Scopri di più",
      list: [
        { id: 1, name: "Dermatologia e Venereologia", desc: "Consultazioni dermatologiche, trattamento delle malattie della pelle e delle IST, dermatologia estetica" },
        { id: 2, name: "Logopedia", desc: "Valutazione e trattamento dei disturbi del linguaggio, della parola e della comunicazione" },
        { id: 3, name: "Medicina Generale", desc: "Consultazioni mediche, monitoraggio della salute e prelievi su appuntamento" },
        { id: 4, name: "Pedicure Medica Specializzata", desc: "Cure mediche specializzate dei piedi e delle unghie" },
        { id: 5, name: "Psicologia di Primo Livello", desc: "Supporto psicologico e psicoterapia individuale di primo livello" },
        { id: 6, name: "Psicoterapia Sistemica", desc: "Terapia di coppia, familiare e sistemica" },
        { id: 7, name: "Psicoanalisi e EMDR", desc: "Psicoterapia analitica e trattamento EMDR dei traumi" },
        { id: 8, name: "Laser Smettere di Fumare", desc: "Trattamento laser auricolare per smettere di fumare e per le dipendenze" },
      ],
    },
    gallery: {
      title: "Il Nostro Spazio",
      subtitle: "Un ambiente caldo e professionale",
    },
    centres: {
      eyebrow: "Due indirizzi a Bruxelles",
      title: "I Nostri Centri Medici",
      subtitle: "Due centri complementari che lavorano in sinergia per offrire cure multidisciplinari di qualità nel cuore di Bruxelles.",
      discover: "Scopri questo centro",
      back: "Torna ai centri",
      all_centres: "Tutti i nostri centri",
      features: "Punti di forza",
      gallery: "Galleria",
      contact: "Contatti",
      transport: "Accesso & Trasporti",
      open_map: "Apri in Maps",
      team: "L'équipe di questo centro",
      home_title: "I nostri due centri",
      home_subtitle: "Due indirizzi, lo stesso impegno per la tua salute.",
    },
    collaborer: {
      eyebrow: "Unisciti al network Psymed",
      title: "Collabora con noi",
      intro: "Sei medico, kinesiterapista, psicologo, psicoterapeuta o un altro professionista della salute alla ricerca di uno studio accogliente, ben situato e completamente attrezzato? Unisciti al network Psymed.",
      abbaye_title: "Centro Psymed Abbaye — Avenue de l\'Hippodrome, Ixelles",
      abbaye_lead: "Con un permesso di urbanistica del Comune di Ixelles, il nostro nuovo centro ti offre 7 studi medici/paramedici con lavabo e una sala polivalente, in un edificio interamente ristrutturato di 280 m², nel cuore degli Étangs di Ixelles — a due passi da Place Flagey e dal quartiere universitario (ULB), con eccellente rete di trasporti (tram 7 & 8, bus 38/59/71).",
      abbaye_pmr: "Interamente accessibile alle persone con mobilità ridotta, con posto di deposito-minuto davanti all\'ingresso.",
      features_title: "Cosa troverai sul posto",
      features: [
        "7 studi da 17 a 23 m², metratura generosa conforme alle norme, mobilio e lavabo integrati",
        "Sala polivalente di 35 m² (interrato) — riabilitazione, formazione, riunioni, affittabile anche separatamente",
        "Cucina attrezzata, spogliatoio e doccia",
        "2 bagni di cui uno accessibile",
        "Ventilazione meccanica (VMC)"
      ],
      pricing_title: "Formule flessibili, spese incluse",
      pricing_note: "Il tuo profilo professionale presente sul sito del centro",
      half_day: "Mezza giornata fissa / settimana",
      half_day_price: "a partire da 155 €/mese",
      full_day: "Giornata intera fissa / settimana",
      full_day_price: "a partire da 280 €/mese",
      cinquantenaire_title: "Centro Psymed Cinquantenaire",
      cinquantenaire_body: "Il nostro centro storico, a due passi dal parco del Cinquantenaire, accoglie professionisti dal 2020. La disponibilità è ora molto limitata: non aspettare a contattarci.",
      cta_title: "Vuoi unirti a noi?",
      cta_body: "Contattaci per organizzare una visita e discutere la formula più adatta alla tua pratica.",
      contact_email: "dottbb@outlook.com",
      contact_phone: "+32 465 64 71 08",
    },
    blog: {
      title: "Notizie",
      subtitle: "Ultime notizie dal Centro Psymed",
      read_more: "Leggi di più",
      view_all: "Vedi tutte le notizie",
      no_posts: "Nessun articolo disponibile al momento.",
      back: "Torna alle notizie",
      all: "Tutte",
      not_found_title: "Articolo non trovato",
      not_found_text: "Questo articolo non esiste o è stato rimosso.",
    },
    contact: {
      title: "Contattaci",
      subtitle: "Due centri al vostro servizio, un solo modulo",
      name: "Il vostro nome",
      email: "La vostra email",
      phone: "Telefono (opzionale)",
      centre_label: "Quale centro ti interessa?",
      centre_any: "Indifferente / entrambi",
      message: "Il vostro messaggio",
      send: "Invia",
      sending: "Invio in corso...",
      success: "Messaggio inviato con successo! Ti risponderemo al più presto.",
      error: "Si è verificato un errore. Riprova.",
      address_title: "Indirizzo",
      address: "Avenue de la Renaissance 21, 1000 Bruxelles",
      building: "Résidence Da Vinci — piano terra sinistra",
      parking: "Parcheggio: facile trovare un posto",
      transport_title: "Trasporti pubblici",
      transport_metro: "Metro: linee 1 e 5 (Schuman o Merode)",
      transport_bus: "Bus: 61 (Chevalerie) | 21, 63, 79 (Michelange)",
      get_directions: "Come arrivare",
    },
    staff: {
      title: "Il Nostro Team",
      subtitle: "Professionisti esperti al vostro servizio",
      appointment: "Prenota",
      schedule: "Orari",
      phone: "Telefono",
      email: "Email",
      learn_more: "Scopri di più",
      back_to_team: "Torna al team",
      practice_at: "Riceve presso",
      qualifications: "Qualifiche",
      domains: "Aree di intervento",
      memberships: "Affiliazioni",
      registrations: "Numeri di registrazione",
      about: "Su di me",
      book_online: "Prenota online",
      contact_pro: "Contatta",
      information: "Informazioni",
    },
    footer: {
      tagline: "Centro medico multidisciplinare nel cuore di Bruxelles",
      quick_links: "Link rapidi",
      privacy: "Informativa sulla privacy",
      rights: "Tutti i diritti riservati",
      professional: "Professionista sanitario? Contattaci per collaborare",
    },
  },
};
